import { useMemo } from "react";
import { PolicyDayPeriodType, PolicyTargetStatus } from "shared";

import { Select } from "../../../../../../common/Atoms/Select";
import { InputTextAddon } from "../../../../../../common/Atoms/InputTextAddon";
import { fieldIsValid } from "../../../../../lib/helper";

import { IFieldProps } from "./fieldProps";

export function DayIndexWithType({
  handleChange,
  policyFormData,
  invalids,
  dayType,
  dayIndexValue,
  onDayIndexChange,
  allowOrLater,
  label,
}: IFieldProps & {
  dayType: `before` | `after` | `on`;
  dayIndexValue: string;
  onDayIndexChange: (e: { value: string; name: string }, dayType?: `before` | `after` | `on`) => void;
  allowOrLater?: boolean;
  label?: string;
}) {
  const options = useMemo(() => {
    const options = [
      {
        label: `Day${policyFormData.grace_period === 1 ? `` : `s`}`,
        value: PolicyDayPeriodType.DAYS,
        tooltip: `All calendar days`,
      },
    ];

    if (dayType !== `on`) {
      options.push(      {
        label: `Weekday${policyFormData.grace_period === 1 ? `` : `s`}`,
        value: PolicyDayPeriodType.WEEKDAYS,
        tooltip: `Skips weekends and holidays in your region.`,
      });
    }

    // only allow the or later if they're doing due date, issue date, or marked paid date and allowOrLater is true
    if (allowOrLater && [PolicyTargetStatus.DUE, PolicyTargetStatus.ISSUED, PolicyTargetStatus.MARKED_PAID, PolicyTargetStatus.INVOICE_AMOUNT_UPDATED, PolicyTargetStatus.PROMISE_BROKEN, PolicyTargetStatus.PROMISE_DUE].includes(policyFormData.target_status)) {
      options.push({
        label: `Day${policyFormData.grace_period === 1 ? `` : `s`} (or later)`,
        value: PolicyDayPeriodType.DAYS_OR_LATER,
        tooltip: `Will be sent up to 30 days after the intended day.`,
      });

      // Add weekdays (or later) option only if dayType is not 'on'
      if (dayType !== `on`) {
        options.push({
          label: `Weekday${policyFormData.grace_period === 1 ? `` : `s`} (or later)`,
          value: PolicyDayPeriodType.WEEKDAYS_OR_LATER,
          tooltip: `Skips weekends and holidays in your region. Will be sent up to 30 days after the intended day.`,
        });
      }
    }

    return options;

  }, [policyFormData.grace_period, policyFormData.policy_type, allowOrLater, policyFormData.target_status, dayType]);

  function handleDaysPeriodTypeChange({ value }) {
    return handleChange({
      value,
      name: `day_period_type`,
    });
  }

  const dropdown = (
    <Select
      options={ options }
      selected={ policyFormData.day_period_type }
      onChange={ handleDaysPeriodTypeChange }
      name={ `day_period_type` }
      className={ `rounded-l-none` }
      nestedInTextField
      anchor={ `bottom` }
    />
  );

  return (
    <>
      <InputTextAddon
        value={ dayIndexValue }
        onChange={ onDayIndexChange }
        name={ `day_index` }
        label={ label }
        invalid={ fieldIsValid(`day_index`, invalids) }
        disabled={ dayType === `on` }
        dataType={ `number` }
        // addOnText={ dayType === `on` ? (policyFormData.day_period_type === PolicyDayPeriodType.DAYS_OR_LATER ? `days or later` : `days`) : undefined }
        addOnElement={ dropdown }
      />
    </>
  );
}
